import { useQuery } from "react-query";
import { fetchNationData } from "./api";

export function useNational(options = {}) {
  return useQuery(["NationalData"], () => fetchNationData(), {
    staleTime: 60000 * 60,
    ...options,
  });
}
